export function Tag(tag: string): ClassDecorator  {
    return component => {
        component.prototype.__TAG = tag;
    };
}
